module.exports = __webpack_public_path__ + "img/DS-J-10.fdc2591d.svg";